import { a as __rest } from '../../tslib.es6.esm.js';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { PauseIcon } from '@iris/react-icons/PauseIcon';
import { PlayIcon } from '@iris/react-icons/PlayIcon';
import carouselPlaybackButtonStyles from './CarouselPlaybackButton.styles.esm.js';
import { cn } from '../../utils/cn.esm.js';

/**
 * CarouselPlaybackButton component for controlling carousel playback
 */
const CarouselPlaybackButton = forwardRef((_a, ref) => {
    var { type, variant = "floating", inverse = false, className, "aria-label": ariaLabel } = _a, props = __rest(_a, ["type", "variant", "inverse", "className", "aria-label"]);
    const { button, icon, wrapper } = carouselPlaybackButtonStyles({
        variant,
        inverse,
        type,
    });
    const defaultAriaLabel = type === "play"
        ? "Start automatic slideshow"
        : "Pause automatic slideshow";
    const Icon = type === "play" ? PlayIcon : PauseIcon;
    return (jsx("button", Object.assign({ ref: ref, "aria-label": ariaLabel || defaultAriaLabel, className: cn(button(), className) }, props, { children: jsx("div", { className: wrapper(), children: jsx(Icon, { "aria-hidden": "true", className: icon() }) }) })));
});
CarouselPlaybackButton.displayName = "CarouselPlaybackButton";

export { CarouselPlaybackButton };
